export const SEASON_LOAD_SUCCESS = 'season/LOAD_SUCCESS';
export const SEASON_CREATE_SUCCESS = 'season/CREATE_SUCCESS';
export const SEASON_EDIT_SUCCESS = 'season/EDIT_SUCCESS';
export const SEASON_DELETE_SUCCESS = 'season/DELETE_SUCCESS';
export const SET_BUSY = 'season/SET_BUSY';
export const UNSET_BUSY = 'season/UNSET_BUSY';
